import { render, staticRenderFns } from "./GroupTabGameplayKpi.vue?vue&type=template&id=8a9f82e4&scoped=true&"
import script from "./GroupTabGameplayKpi.vue?vue&type=script&lang=js&"
export * from "./GroupTabGameplayKpi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9f82e4",
  null
  
)

export default component.exports